import React, { useEffect, useState } from "react";
import { Divider, Grid, Header, Tab, Button, Label } from "semantic-ui-react";
import { Field, reduxForm, FieldArray } from "redux-form";
import {
  renderTextField,
  activeStatus,
  renderOptionField,
} from "../formcomponents";
import FileListUpload from "./FileListUpload";
import { useParams } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../formcomponents/Constants";
import UserProfile from "./UserProfile";
import NewCompany from "./NewCompany";
import ModifyCompany from "./ModifyCompany";

const CreateCompany = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;
  let { urlId, id } = useParams();
  const [companyData, setcompanyData] = useState("");
  useEffect(() => {
    console.log("userId", urlId);
    if (urlId !== "null") {
      getCompanyDetails();
    }
  }, []);

  const getCompanyDetails = async () => {
    await axios
      .post(BaseUrl + "getCompanyDetails", { companyId: id })
      .then((res) => {
        setcompanyData(res.data);
        console.log("res", res.data);
        initializeData(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const initializeData = (tempData) => {
    props.initialize({
      companyId: tempData.companyId,
      userId: tempData.userId,
      sponsorName: tempData.sponsorName,
      companyName: tempData.companyName,
      localSponsorAndPartnerName: tempData.localSponsorAndPartnerName,
      status: tempData.status,
      nationality: tempData.nationality,
      licenseNumber: tempData.licenseNumber,
      issueDate: tempData.issueDate,
      expiryDate: tempData.expiryDate,
      expiryStatus: tempData.expiryStatus,
      immigrationCardNo: tempData.immigrationCardNo,
      labourCardNo: tempData.labourCardNo,
      category: tempData.category,
      contactPerson: tempData.contactPerson,
      contactNumber: tempData.contactNumber,
      eMailId: tempData.eMailId,
      filesList: tempData.filesList,
    });
  };
  const sumbitForm = (values) => {
    console.log(values);

    // const submitObject = {
    //   sponsorName: values.sponsorName,
    //   companyName: values.companyName,
    //   localSponsorAndPartnerName: values.localSponsorAndPartnerName,
    //   status: values.status,
    //   nationality: values.nationality,
    //   licenseNumber: values.licenseNumber,
    //   issueDate: values.issueDate,
    //   expiryDate: values.expiryDate,
    //   expiryStatus: values.expiryStatus,
    //   immigrationCardNo: values.immigrationCardNo,
    //   labourCardNo: values.labourCardNo,
    //   category: values.category,
    //   contactPerson: values.contactPerson,
    //   contactNumber: values.contactNumber,
    //   eMailId: values.eMailId,
    //   filesList: values.filesList,
    // };

    console.log("submitObject", values);

    axios
      .post(BaseUrl + "/editCompany", values)
      .then((res) => {
        console.log("res", res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const testObject = {
    name: "test",
    cname: "abc",
  };
  const panes = [
    {
      menuItem: "Personal",
      render: () => (
        <Tab.Pane>
          {" "}
          {/* <Grid columns={3}>
            <Grid.Row>
              <Grid.Column>
                <Field
                  name="contactPerson"
                  label="Contact Persion"
                  type="text"
                  component={renderTextField}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  name="contactNumber"
                  label="Contact Number"
                  type="text"
                  component={renderTextField}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  name="eMailId"
                  label="Email Id"
                  type="email"
                  component={renderTextField}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>{" "} */}
          <UserProfile userId={urlId} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "New Company",
      render: () => (
        <Tab.Pane>
          <ModifyCompany />
        </Tab.Pane>
      ),
    },

    {
      menuItem: "Modify Company",
      render: () => (
        <Tab.Pane>
          <NewCompany userId={id} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Other Requests",
      render: () => <Tab.Pane>{/* <NewCompany /> */}</Tab.Pane>,
    },
    // {
    //   menuItem: "Files",
    //   render: () => (
    //     <Tab.Pane>
    //       {" "}
    //       <Grid.Row>
    //         <FieldArray name="filesList" component={FileListUpload} />
    //       </Grid.Row>
    //       {companyData !== "" && (
    //         <div class="ui equal width grid">
    //           {companyData.filesList.map((item, i) => (
    //             <div class="column">
    //               <Label>{item.fileType}</Label>
    //               <br />
    //               <img
    //                 src={`https://travelpack365.com:8443/filestorage/silverstar/images/${item.fileName}`}
    //                 style={{
    //                   width: " 200px",
    //                   height: "200px",
    //                 }}
    //                 //filestorage/parmartour/images/
    //               />
    //             </div>
    //           ))}
    //         </div>
    //       )}
    //     </Tab.Pane>
    //   ),
    // },
  ];

  const colors = "red";

  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          Create Company
        </Header>
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      <Tab
        menu={{
          colors,
          fluid: true,
          vertical: true,
          tabular: true,
        }}
        panes={panes}
      />
      {/* <Grid columns={3}>
        <Grid.Row>
          <Grid.Column>
            <Field
              name="labourCardNo"
              label="Labour Card No"
              type="text"
              component={renderTextField}
            />
          </Grid.Column>
          <Grid.Column>
            <Field
              name="category"
              label="Category"
              type="text"
              component={renderTextField}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid> */}
      <br />
      <Divider hidden />
    </div>
  );
};

export default reduxForm({
  form: "CreateCompany",
  // enableReinitialize: true,
})(CreateCompany);

// companyId: "",
//       userId: "",
//       sponsorName: values.sponsorName,
//       companyName: "",
//       localSponsorAndPartnerName: "",
//       status: "",
//       nationality: "",
//       licenseNumber: "",
//       issueDate: "",
//       expiryDate: "",
//       expiryStatus: "",
//       immigrationCardNo: "",
//       labourCardNo: "",
//       category: "",
//       contactPerson: "",
//       contactNumber: "",
//       eMailId: "",
